import { CustomLink } from '../CustomLink/CustomLink';
import 'react-tooltip/dist/react-tooltip.css';
import { Tooltip } from 'react-tooltip';
import styles from "./SectionCard.module.css";
import FleekCoin from "../../asset/icons/fleek-coin-logo.png";
import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

export const SectionCard = ({ data }) => {
  const { 
    service: { service_name, logo_url }, 
    starts_from, 
    discount_percentage, 
    vendor_web_path 
  } = data;
  
  const [isExpanding, setIsExpanding] = useState(false);
  const navigate = useNavigate();
  const cardRef = useRef(null);
  
  const handleClick = (e) => {
    e.preventDefault();
    if (isExpanding) return;
    
    // Handle Chess.com affiliate redirect
    if (vendor_web_path === 'chess.com') {
      
      window.open('https://chess.com/membership?ref_id=372424947', '_blank');
      return;
    }
    
    setIsExpanding(true);
    
    // Delay navigation until animation completes
    setTimeout(() => {
      navigate('/brand/' + vendor_web_path);
    }, 400); // Match animation duration
  };
  
  return (
    <div 
      ref={cardRef}
      className={`${styles.logoCard} ${isExpanding ? styles.expanding : ''}`} 
      onClick={handleClick}
    >
      <div className={styles.logoWrapper}>
        <img className={styles.logoOnly} alt="logo" src={logo_url} />
        {discount_percentage > 0 && (
          <div className={styles.logoBadge}>
            <span className={styles.discountText}>{discount_percentage}% off</span>
            <img className={styles.coinIcon} src={FleekCoin} alt="FleekCoin"/>
          </div>
        )}
      </div>
      <div className={styles.logoTextContainer}>
        <p 
          className={styles.titleText}
          data-tooltip-id={service_name}
          data-tooltip-content={service_name}
          data-tooltip-place="bottom"
        >
          {service_name}
        </p>
        <p className={styles.priceText}>{starts_from}</p>
      </div>
      <Tooltip id={service_name} />
    </div>
  );
}; 